import PropTypes from 'prop-types';
import React from 'react';

function AngleRight(props) {
  const { fill } = props;
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.61846 21.3687L17.5574 12.4422C17.8018 12.1982 17.8019 11.8022 17.5577 11.558L8.61846 2.62066"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

AngleRight.propTypes = {
  fill: PropTypes.string.isRequired
};

export default AngleRight;
